import { DiamondNode, DiamondNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class ComplexGatewayView extends DiamondNode {
  getShape() {
    const { model } = this.props;
    const { x, y, rx, ry } = model;
    void model.properties.__tv; // MobX: re-render on theme change
    const style = model.getNodeStyle();
    const points = `${x},${y - ry} ${x + rx},${y} ${x},${y + ry} ${x - rx},${y}`;

    return h('g', {}, [
      h('polygon', {
        points,
        ...style,
      }),
      // Asterisk marker (BPMN standard for Complex Gateway)
      h('path', {
        d: `M ${x} ${y - 10} L ${x} ${y + 10}
            M ${x - 10} ${y} L ${x + 10} ${y}
            M ${x - 7} ${y - 7} L ${x + 7} ${y + 7}
            M ${x + 7} ${y - 7} L ${x - 7} ${y + 7}`,
        stroke: style.stroke,
        strokeWidth: 2.5,
        fill: 'none',
      }),
    ]);
  }
}

class ComplexGatewayModel extends DiamondNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.rx = 30;
    this.ry = 30;
    initLabelOffset(this, data, this.ry + 18);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'complexGateway');
    style.stroke = t.stroke || '#595959';
    style.strokeWidth = t.strokeWidth ?? 2;
    style.fill = t.fill || '#fafafa';
    return style;
  }
}

export const ComplexGateway = {
  type: 'epx:ComplexGateway',
  view: ComplexGatewayView,
  model: ComplexGatewayModel,
};
